import merge from 'lodash/merge';

export const setOptions = ({ commit }, options) => {
	const DEFAULT_OPTIONS = { allowClose: true };
	const opts = merge(DEFAULT_OPTIONS, options);

	commit('SET_MODAL', opts);
};
